import { API_URL } from "../Constants"
import { startLoading, endLoading, SnackBar } from './Common'
import store from "../store"

export function storeQuestions(baseline, step = 1) {
    return { type: 'STORE_BASELINE_ONE', baseline, step };
}

export function storeBaselineScore(score = null, baseline_score = null, step) {
    return { type: 'STORE_BASELINE_SCORE', score, baseline_score, step };
}

export function clearBaseLineStore() {
    return { type: 'CLEAR_BASELINE_SCORE' };
}

export function baselineTestAnswers(data, step) {
    return function (dispatch) {
        dispatch(startLoading())
        dispatch(SnackBar(true, 'Loading.....', 'info'))
        fetch(API_URL + "alertness/save", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
                'Authorization': 'Bearer ' + store.getState().auth.access_token
            },
            body: JSON.stringify({ data })
        }).then(response => response.json(), error => console.log('An error occurred.', error))
            .then((json) => {
                if (json.status === "success") {
                    dispatch(storeBaselineScore(json.score, json.baseline_score, step))
                }
                dispatch(endLoading())
            })
    }
}